import ModalButtonTriggerExample from "../../../../../../packages/design-system/entry-points/examples/constellation/modal-button-trigger";
import RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_button_trigger from "!!raw-loader!../../../../../../packages/design-system/entry-points/examples/constellation/modal-button-trigger";
import * as React from 'react';
export default {
  ModalButtonTriggerExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmodal_button_trigger,
  React
};